import { render, staticRenderFns } from "./CapacitacionFormModal.vue?vue&type=template&id=7f401bf8"
import script from "./CapacitacionFormModal.vue?vue&type=script&lang=js"
export * from "./CapacitacionFormModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports